import * as React from "react";
import { Collapsible as CollapsiblePrimitive } from "radix-ui";

/**
 * Hand-added rather than `bunx shadcn add` (#348 — that command overwrites
 * customised files in this directory). Nothing here needs customising: the
 * sidebar's module rows use it exactly as radix ships it, with the open
 * state controlled from `AppSidebar` rather than left to the primitive.
 *
 * No `data-slot` here, unlike this file's other exports and every other
 * primitive in `ui/`: `AppSidebar` always renders this `asChild` over a
 * `SidebarMenuItem`, and radix's own prop merge for that case lets whichever
 * `data-slot` sits closer to the root win — ours would silently replace
 * `"sidebar-menu-item"` on every module row that has sections instead of
 * layering onto it.
 */
function Collapsible({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.Root>) {
  return <CollapsiblePrimitive.Root {...props} />;
}

function CollapsibleContent({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.Content>) {
  return (
    <CollapsiblePrimitive.Content data-slot="collapsible-content" {...props} />
  );
}

export { Collapsible, CollapsibleContent };
